// extracted by mini-css-extract-plugin
export default {"container":"styles_container__TC-0Q","deck":"styles_deck__1-pmx","Thanks":"styles_Thanks__KTZNq"};